export const locale = {
  lang: 'en',
  data: {
    'COMPLEX_SELECTOR': {
      'CURRENT_COMPLEX': 'Current complex',
    },
  }
};
